module.exports = __webpack_public_path__ + "img/1-2.4abd8438.png";